import { ApisauceInstance } from 'apisauce';

/**
 * PUT /v1/driver_bonus/preview — a dry run of the PUT /overrides REPLACE: the
 * body is the record's complete desired override state (see
 * buildOverrideState). Every kind is always sent; an empty kind (or a null
 * qualifier) previews that kind as cleared, so removing the week's last override
 * is just an empty state.
 */
const putBonusPreview = ({
  api,
  driver,
  bonusProgramId,
  intervalId,
  bonusDatasetRecordId,
  criteriaOverrides,
  qualifierOverride,
  valueOverrides,
  rewardOverrides,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  intervalId: string;
  bonusDatasetRecordId: string;
} & BonusTypes.Overrides.OverrideState) => {
  return api.put<BonusTypes.Rewards.DriverRewardsOutput>(
    `/v1/driver_bonus/preview?driver=${driver}&period=${intervalId}&driver_bonus_program_id=${bonusProgramId}&bonus_dataset_record_id=${bonusDatasetRecordId}`,
    {
      criteriaOverrides,
      qualifierOverride,
      valueOverrides,
      rewardOverrides,
    },
  );
};

export default putBonusPreview;
